import { Typography, Box } from '@mui/material';
import React from 'react';
import {
  ExpandableCard,
  ExpandableCardProps,
} from '~/src/components/ExpandableCard/ExpandableCard';
import { ProjectStackFieldGroup } from '~/src/entities/project';
import { useCardChip } from './useCardChip';

type PopulatePageCardBodyProps = React.PropsWithChildren<{
  expanded: boolean;
  onChangeExpanded: () => void;
  callbackAfterExpanded: () => void;
  extra?: ExpandableCardProps['extra'];
  footer?: ExpandableCardProps['footer'];
  group: ProjectStackFieldGroup;
  headerSubDescription?: React.ReactNode;
}>;

export const PopulatePageCardBody = ({
  expanded,
  onChangeExpanded,
  group,
  callbackAfterExpanded,
  children,
  extra,
  footer,
  headerSubDescription,
}: PopulatePageCardBodyProps) => {
  return (
    <ExpandableCard
      uncollapsibleProps={{
        sx: {
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: 'white',
        },
      }}
      collapsibleProps={{
        addEndListener: () => {
          callbackAfterExpanded();
        },
      }}
      expanded={expanded}
      onChangeExpanded={onChangeExpanded}
      cardProps={{
        id: group.gid,
        sx: { marginBottom: 3, overflow: 'inherit' },
      }}
      header={
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
          sx={{ minHeight: '32px' }}
        >
          <Box display={'flex'} flexDirection={'column'}>
            <Typography variant="subheading">{group.label}</Typography>
            {headerSubDescription}
          </Box>
          {useCardChip(group.fields)}
        </Box>
      }
      extra={extra}
      footer={footer}
    >
      {children}
    </ExpandableCard>
  );
};
